import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export type Props = {
  hash: string;
  onClick: () => void;
  mode: 'new' | 'detail' | 'edit';
};

export const BackLink: React.FC<Props> = ({ hash = '', mode, onClick }) => {
  const { t } = useTranslation();
  const onClickHandler = useCallback(() => {
    onClick();
    window.location.hash = hash;
  }, [hash, onClick]);

  return mode === 'detail' ? null : (
    <Styled
      data-test={`link-back-${hash}`}
      className="subscription-content-change"
      onClick={onClickHandler}
    >
      <Icon name="edit" />
      {t('ui.action.changeNow')}
    </Styled>
  );
};

const Styled = styled.a`
  margin-left: 1.5em;
  cursor: pointer;
  font-size: 0.9em;
`;
